import { type AiApiClient, useAiApiClient } from "#lib/AiApiClient.ts";
import { AiQueryKeys } from "#lib/AiQueryKeys.ts";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

export const getSmartReportQueryOptions = (client: AiApiClient) => {
    return queryOptions({
        queryKey: AiQueryKeys.GetSmartReport(),
        queryFn: async () => {
            const result = await client.getSmartReport();

            return result.smartReport;
        }
    });
};

export const useGetSmartReportSuspenseQuery = () => {
    const client = useAiApiClient();

    return useSuspenseQuery(getSmartReportQueryOptions(client));
};
